
import React from 'react';
import $ from 'jquery';
import noUiSlider from 'nouislider';
import wNumb from 'wnumb';

let sources = require('../../config.json');
let search = 0;

class LandSearchBar extends React.Component {

    constructor(props) {
        super(props);
        this.searchfields_url = sources.searchfields;

        let p = this.props.search;
        let urlParams = { frontage: null, land: null };
        if( 'frontage' in p && p.frontage.length === 2) {
            urlParams.frontage = { start: p.frontage[0], end: p.frontage[1] };
        }
        if( 'land' in p && p.land.length === 2) {
            urlParams.land = { start: p.land[0], end: p.land[1] };
        }

        this.state = {
            onSearchClicked: props.onSearchClick,
            onResetClicked: props.onResetClick,
            urlParams: urlParams,
            landSearchPath: '/land-for-sale/search',
            frontageBounds: {
                min: 14,
                max: 30
            },
            frontageVal: {
                start: 14,
                end: 30
            },
            frontageOpts: {
                step: 1,
                margin: 1
            },
            frontageSlider: null,
            landBounds: {
                min: 400,
                max: 700
            },
            landVal: {
                start: 400,
                end: 700
            },
            landOpts: {
                step: 10,
                margin: 50
            },
            landSlider: null
        };

        this.landSliderUpdate = this.landSliderUpdate.bind(this);
        this.frontageSliderUpdate = this.frontageSliderUpdate.bind(this);
        this.onSearchClickEvent = this.onSearchClickEvent.bind(this);
        this.onSearchResetEvent = this.onSearchResetEvent.bind(this);
        this.initializeSliders = this.initializeSliders.bind(this);
        this.onInitializeEvent = this.onInitializeEvent.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        search = $('#searchBox').offset().top;
        window.addEventListener('scroll', this.handleScroll);

        let searchFields = $.ajax({url: this.searchfields_url,dataType:'json'});
        $.when(searchFields).done(function(search) {

            let newFrontage = { start: search.frontage.min, end: search.frontage.max };
            if(this.state.urlParams.frontage !== null) { newFrontage = this.state.urlParams.frontage; }

            let newLand = { start: search.area.min, end: search.area.max };
            if(this.state.urlParams.land !== null) { newLand = this.state.urlParams.land; }

            let newState = Object.assign(this.state, {
                frontageBounds: search.frontage,
                frontageVal: newFrontage,
                landBounds: search.area,
                landVal: newLand
            });
            this.setState(newState);
            this.initializeSliders();
            this.onInitializeEvent();
        }.bind(this));
    }

    handleScroll() {
        if ($(window).scrollTop() >= search){
            $('body').addClass('sticky-filter');

            $('.accordion__content').stop(true).slideUp('slow');
            $('.accordion__toggle').removeClass('open');

        } else if ($(window).scrollTop() < search) {
            $('body').removeClass('sticky-filter');

            $('.accordion__content').stop(true).slideDown('slow');
            $('.accordion__toggle').addClass('open');
        }
    }

    initializeSliders() {
        // Land Slider
        let landSlider = document.getElementById('slider--land-size');
        noUiSlider.create(landSlider, {
            connect: true,
            start: [ this.state.landVal.start, this.state.landVal.end ],
            margin: this.state.landOpts.margin,
            step: this.state.landOpts.step,
            range: this.state.landBounds,
            format: wNumb({
                decimals: 0
            })
        });

        // Display the slider value
        landSlider.noUiSlider.on('update', this.landSliderUpdate );

        // Frontage Slider
        let frontageSlider = document.getElementById('slider--frontage');
        noUiSlider.create(frontageSlider, {
            connect: true,
            start: [ this.state.frontageVal.start, this.state.frontageVal.end ],
            margin: this.state.frontageOpts.margin,
            step: this.state.frontageOpts.step,
            range: this.state.frontageBounds,
            format: wNumb({
                decimals: 0
            })
        });

        // Display the slider value
        frontageSlider.noUiSlider.on('update', this.frontageSliderUpdate );

        // Store sliders into state
        let newState = Object.assign(this.state, {
            frontageSlider: frontageSlider,
            landSlider: landSlider
        });
        this.setState(newState);
    }

    landSliderUpdate(values, handle, unencoded, isTap, positions) {
        let newState = Object.assign(this.state, {
            landVal: {
                start: values[0],
                end: values[1]
            }
        });
        this.setState(newState);
    }

    frontageSliderUpdate(values, handle, unencoded, isTap, positions) {
        let newState = Object.assign(this.state, {
            frontageVal: {
                start: values[0],
                end: values[1]
            }
        });
        this.setState(newState);
    }

    onSearchResetEvent() {
        if(this.state.onResetClicked !== null) {
            this.state.onResetClicked();
        }
        let newState = Object.assign(this.state, {
            frontageVal: {
                start: this.state.frontageBounds.min,
                end: this.state.frontageBounds.max
            },
            landVal: {
                start: this.state.landBounds.min,
                end: this.state.landBounds.max
            }
        });
        this.setState(newState);
        this.state.landSlider.noUiSlider.set([
            this.state.landVal.start,
            this.state.landVal.end,
        ]);
        this.state.frontageSlider.noUiSlider.set([
            this.state.frontageVal.start,
            this.state.frontageVal.end,
        ]);
    }

    onSearchClickEvent() {
        if(this.state.onSearchClicked !== null) {
            this.state.onSearchClicked(this.state.frontageVal, this.state.landVal, this.state.landSearchPath);
        }
    }

    onInitializeEvent() {
        if(this.state.urlParams.frontage !== null || this.state.urlParams.land !== null) {
            this.onSearchClickEvent();
        }
    }

    accordionToggle() {
        $('.accordion__content').stop(true).slideToggle('slow');
        $('.accordion__toggle').toggleClass('open');
    }

    render() {
        return (
            <div className={this.props.divClass} id="searchBox">
                <div className="filter__header">
                    <div className="cf">
                        <div className="filter-toggle accordion__toggle open" onClick={this.accordionToggle}>
                            <img className="toggle__down" src='https://storage.googleapis.com/genfyansford.data.insiteinteractive.com.au/assets/images/icons/chevron-down--grey.svg' alt="" width="15px"/>
                            <img className="toggle__up" src='https://storage.googleapis.com/genfyansford.data.insiteinteractive.com.au/assets/images/icons/chevron-up--grey.svg' alt="" width="15px"/>
                            <span> Filter Results</span>
                        </div>

                        <div className="link__filter--reset" id="filter--reset" onClick={this.onSearchResetEvent} >Reset Filter</div>
                    </div>
                </div>

                <div className="filter__content cf accordion__content">
                    <div className="filter__wrap dt-md cf">
                        <div className="filter-col filter--slider dtc-md v-mid-md">
                            <div className="range__slider range__slider--frontage">
                                <div className="cf">
                                    <div className="slider__label filter__label fl"> Frontage </div>
                                    <div className="slider__values fr">
                                        <span id="lower-value--frontage">{this.state.frontageVal.start}</span>m to
                                        <span id="upper-value--frontage"> {this.state.frontageVal.end}</span>m
                                    </div>
                                </div>
                                <div className="slider noUi-target noUi-ltr noUi-horizontal" id="slider--frontage" >
                                </div>
                            </div>
                        </div>
                        <div className="filter-col filter--slider first dtc-md v-mid-md">
                            <div className="range__slider range__slider--land">
                                <div className="cf">
                                    <div className="slider__label filter__label fl"> Land Size </div>
                                    <div className="slider__values fr">
                                        <span className="land-size" id="lower-value--land">{this.state.landVal.start}</span>m<sup>2</sup> to
                                        <span className="land-size" id="upper-value--land"> {this.state.landVal.end}</span>m<sup>2</sup>
                                    </div>
                                </div>

                                <div className="slider noUi-target noUi-ltr noUi-horizontal" id="slider--land-size" >
                                </div>
                            </div>
                        </div>

                        <div className="filter-col last dtc-md v-mid-md">
                            <div className="btn__container">
                                <div className="btn btn__action btn__filter-search searching" id="filter-search-btn" onClick={this.onSearchClickEvent}>
                                    Search<span className="searching-text">ing</span><span className="searching-dots">.</span><span className="searching-dots">.</span><span className="searching-dots">.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

    }
}

export default LandSearchBar;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/elements/LandSearchBar.js
 **/